export default __webpack_public_path__ + "static/media/ibi.de7ce589.png";